const messages = (value) =>
    []
        .concat(value)
        .filter((v) => typeof v === "string")
        .join(" ");

// The lists of rows an order has, by the key the API uses for them.
const ROW_GROUPS = {order_items: "items", order_products: "products", order_devices: "devices"};

/**
 * Maps a DRF validation payload for the order create endpoint into
 * form-friendly pieces.
 *
 * DRF nests errors: `order_items: [{quantity: ["..."]}, {}]` for row errors,
 * `order_items: ["..."]` for list-level ones.
 *
 * @param {{response?: {status?: number, data?: any}}} error
 * @param {{editing?: boolean}} [options] whether the request was an edit, not a creation
 * @returns {{
 *   general: string[],
 *   fields: Record<string, string>,
 *   items: Record<number, Record<string, string>>,
 *   products: Record<number, Record<string, string>>,
 *   devices: Record<number, Record<string, string>>,
 * }}
 */
export const parseOrderErrors = (error, {editing = false} = {}) => {
    const result = {general: [], fields: {}, items: {}, products: {}, devices: {}};
    const data = error.response?.data;

    if (editing && error.response?.status === 409) {
        result.general.push("O status da ordem mudou e ela não pode mais ser editada.");
        return result;
    }
    if (error.response?.status !== 400 || !data || typeof data !== "object") {
        result.general.push(`Não foi possível ${editing ? "salvar" : "criar"} a ordem de serviço. Tente novamente.`);
        return result;
    }

    for (const [key, value] of Object.entries(data)) {
        const rowGroup = ROW_GROUPS[key] ?? null;

        if (rowGroup && Array.isArray(value)) {
            value.forEach((row, index) => {
                // DRF pads valid rows with {}.
                if (row && typeof row === "object" && Object.keys(row).length) {
                    result[rowGroup][index] = Object.fromEntries(Object.entries(row).map(([k, v]) => [k, messages(v)]));
                } else if (typeof row === "string") {
                    result.general.push(row);
                }
            });
        } else if (key === "non_field_errors" || key === "detail") {
            result.general.push(messages(value));
        } else if (rowGroup) {
            result.general.push(messages(value));
        } else {
            result.fields[key] = messages(value);
        }
    }
    return result;
};
